export type Role = 'agent' | 'attorney' | 'buyer' | 'lender' | 'other' | 'seller';
export type DefaultRole = 'buyer';

export type Client = {
    id: ClientInfoFormRowIndex;
    email: string;
    phone: string;
    role?: Role;
    first: string;
    last: string;
    identity_verified?: boolean;
};

/** Extends a Client model with properties expected by the MultipleSelect lib */
export interface MultipleSelectClient extends Client {
    value: ClientInfoFormRowIndex;
    text: string;
}

export type ClientInfoFormRowIndex = string; // Form-row index as string (e.g. "0", "1", "2", …)

/** Valid contact field keys that can be edited (non-array string properties) */
export type ContactFieldKey = keyof Pick<MultipleSelectClient, 'email' | 'phone' | 'first' | 'last'>;

export type EditAvailableClientValues = Pick<Client, 'first' | 'last' | 'email' | 'phone' | 'role'>;

export interface ClientInputs {
    emails: { name: string; value: string }[];
    phones: { name: string; value: string }[];
    roles: { name: string; value: Client['role'] }[];
    firsts: { name: string; value: string }[];
    lasts: { name: string; value: string }[];
}

export interface TPSDocument {
    id: string;
    disabled?: boolean;
    label: string;
    name: string;
    source: string;
    value: string;
}

export interface TPSOrderInfo {
    id: number;
    address: string;
    amount_down: string | null;
    autoSelectDocuments: boolean;
    balance_due: string | null;
    branch_id: number;
    clients: Client[];
    close_date: string;
    created_at: string;
    deleted_at: string | null;
    documents: TPSDocument[];
    earnest_money: string | null;
    force_wire_doc_selection_true: boolean;
    hideRecvWire: boolean;
    hideSendDocs: boolean;
    hideSendWire: boolean;
    notes?: string;
    notified_at: string | null;
    owned_by_user_id: number;
    ref_number: string;
    sales_price: string;
    street_view_url: string | null;
    title_id: number;
    transaction_type: string | null;
    updated_at: string;
    uploaded_at: string | null;
    vendor_order_id: string;
    vendor_transaction_id: string;
    vendor: string;
    wire_doc_id: number;
}

/** @todo [CLENG-1199] remove this */
export interface AddFileGlobalFunctions {
    removeClient: (that: HTMLElement) => void;
}

export interface FileFormScroller {
    scrollToClientSection: () => void;
    scrollToDocumentSection: () => void;
}

export enum AddFileFormSectionIds {
    FILE_DETAILS = 'file-details-section',
    FILE_NOTIFICATION = 'fileNotificationSection',
    CLIENTS = 'clients-section',
    SEND_WIRE_INSTRUCTIONS = 'sendWireSection',
    DOCUMENTS = 'documentUploadSection',
    REQUEST_WIRE_INFORMATION = 'recvWireSection',
    REQUEST_IDENTITY_VERIFICATION = 'request-identity-verification-section',
}
